<xena-modal label="Settings" i18n-label="@@Settings_label" class="modal-extended-hight" [open]="open">
  <div [formGroup]="form">
    <div class="mb-3">
      <h4 class="m-0" i18n="@@fiscal_approval_settings_Voucher_registration">Voucher registration</h4>
    </div>
    <div class="mb-4">
      <xena-checkbox formControlName="vouchersMustBeApproved"
        i18n="@@fiscal_approval_settings_approved_order_responsilbles"> Vouchers must be approved by order responsibles
      </xena-checkbox>
    </div>
    <div class="mb-5">
      <xena-select formControlName="moveToResourceId" label="Move to this inbox for bookkeeping"
        i18n-label="@@fiscal_approval_settings_move_to_inbox" hoist>
        <xena-menu-item *ngFor="let prc of partnerResourceContexts" [value]="prc.id">{{ prc.alias || prc.name }}</xena-menu-item>
      </xena-select>
    </div>
    <div class="mb-3">
      <h4 class="m-0" i18n="@@fiscal_approval_settings_responsibles">Responsibles</h4>
    </div>
    <div class="mb-4">
      <xena-checkbox formControlName="addSecondaryResponsible"
        i18n="@@fiscal_approval_settings_approved_order_secondary_responsible"> Add secondary responsible to sales orders
      </xena-checkbox>
    </div>
  </div>
  <xena-button slot="footer" (click)="cancel()" mode="ghost"
    i18n="@@fiscal_approval_settings_cancelButton">Cancel</xena-button>
  <xena-button slot="footer" (click)="save()" type="primary" i18n="@@fiscal_approval_settings_saveButton"
    [loading]="saving">Save</xena-button>
</xena-modal>
